import { render, staticRenderFns } from "./LoadsList.vue?vue&type=template&id=547e600c&scoped=true"
import script from "./LoadsList.vue?vue&type=script&lang=js"
export * from "./LoadsList.vue?vue&type=script&lang=js"
import style0 from "./LoadsList.vue?vue&type=style&index=0&id=547e600c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e600c",
  null
  
)

export default component.exports